<template>
	<div class="wishlist shadow-box flex-center" @click.stop="onClick()">
		<div class="heart">
			<transition name="bounce">		
				<i class="fas fa-heart" v-if="isOnWishlist"></i>
			</transition>
			<i class="far fa-heart" v-if="!isOnWishlist"></i>
		</div>
		<!-- <transition name="heart-float-left" @before-enter="beforeEnter">
			<div v-if="isOnWishlist" class='heart-float' :style="[randomDirection]">
				<i class="fas fa-heart"></i>
			</div>
		</transition> -->
		<!-- <transition name="bounce">
			<div v-if="isOnWishlist" class='bounce'>	
				<i class="fas fa-heart"></i>
			</div>
		</transition> -->
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				floating: false
			}
		},

		props: {
			isOnWishlist: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			randomDirection () {
				if (!this.floating) return {
					transform: `translateY(0px) translateX(0px) scale(0.4)`
				}
				return {
					transform: `translateY(0px) translateX(40px) scale(0.4)`
				}
			}
		},

		methods: {
			onClick () {
				// this.startAnimation()
				this.$emit('onClick')
			},

			beforeEnter () {
				this.floating = true
			},

			enter () {
				this.floating = true
			},

			afterEnter () {
				this.floating = false
			}
		}
	}
</script>

<style scoped>
	.heart-float {
		position: absolute;
		opacity: 0;
	}

	.wishlist {
		border-radius: 50%;
		background: white;
		height: 30px;
		width: 30px;
		margin: 10px;
		cursor: pointer;
	}

	.heart {
		margin-bottom: -2px;
		font-size: 15px;
	}

	.heart-float-enter-active,
	/*.heart-float-leave-active,*/
	/*.heart-float-left-enter-active,*/
	/*.heart-float-left-leave-active */
	/*{*/
		/*transition: all .8s ease-in;*/
		/*animation: bounce-in .5s;*/
	/*}*/

	.heart-float-enter,
	.heart-float-left-enter {
		/*opacity: 1;*/
		
	}

	.bounce-enter-active {
		animation: bounce-in .5s;
	}

	.bounce-leave-active {
		display: none;
	}

	@keyframes bounce-in {
	  0% {
	    transform: scale(0);
	  }
	  50% {
	    transform: scale(1.5);
	  }
	  100% {
	    transform: scale(1);
	  }
	}

</style>